
import React from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { Zap, LayoutGrid, Settings } from 'lucide-react';
import { useSession } from '../context/SessionContext';

const NavBtn = ({ active, icon: Icon, label, onClick, count }: any) => (
    <button
        onClick={onClick}
        className={`
            flex flex-col items-center justify-center gap-0.5 
            transition-all relative flex-1 min-w-0
            py-2 px-1
            ${active ? 'text-blue-600' : 'text-slate-400'}
            hover:bg-slate-50 active:bg-slate-100
            touch-manipulation
        `}
        style={{ WebkitTapHighlightColor: 'transparent' }}
    >
        <Icon className="w-6 h-6 sm:w-5 sm:h-5" strokeWidth={active ? 2.5 : 2} />
        {count > 0 && (
            <span className="absolute top-0.5 right-1/4 bg-red-600 text-white text-[9px] font-bold w-4 h-4 rounded-full border-2 border-white flex items-center justify-center">
                {count}
            </span>
        )}
        <span className="text-[10px] sm:text-[9px] font-bold uppercase tracking-tight mt-0.5">
            {label}
        </span>
    </button>
);

export const WorkerLayout: React.FC = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { broadcastJobs } = useSession();

    // Determine active tab based on path
    const getActiveTab = (path: string) => {
        if (path.startsWith('/worker/task')) return 'tasks';
        if (path.startsWith('/worker/settings')) return 'settings';
        return 'home';
    };

    const activeTab = getActiveTab(location.pathname);

    return (
        <div className="flex flex-col h-screen overflow-hidden bg-white safe-top">
            <main className="flex-1 relative overflow-hidden flex flex-col min-h-0 pb-16 sm:pb-14">
                <Outlet />
            </main>

            {/* Mobile Bottom Navigation - Fixed */}
            <nav
                className="
                    fixed bottom-0 left-0 right-0
                    bg-white border-t border-slate-200
                    flex flex-row justify-around items-stretch
                    safe-bottom z-[9999]
                    shadow-[0_-2px_10px_rgba(0,0,0,0.08)]
                    h-16 sm:h-14
                "
                style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}
            >
                <NavBtn
                    active={activeTab === 'home'}
                    icon={Zap}
                    label="Home"
                    onClick={() => navigate('/worker')}
                />
                <NavBtn
                    active={activeTab === 'tasks'}
                    icon={LayoutGrid}
                    label="Tasks"
                    onClick={() => navigate('/worker/task')}
                    count={broadcastJobs.length}
                />
                <NavBtn
                    active={activeTab === 'settings'}
                    icon={Settings}
                    label="Setting"
                    onClick={() => navigate('/worker/settings')}
                />
            </nav>
        </div>
    );
};
